<template>
  <el-main>
    <el-table :data="list" :header-cell-style="{ 'background-color': '#F8F9FA' }" row-key="id">
      <template slot="empty">
        <No />
      </template>
      <el-table-column prop="nickname" label="用户信息" width="200" align="center">
        <template v-slot="{ row }">
          <userInfo :name="row.nickname" :avatar="row.user_avatar"></userInfo>
        </template>
      </el-table-column>
      <el-table-column prop="identity_type" label="合伙人身份" width="200" align="center">
        <template v-slot="{ row }">
          <span v-if="row.identity_type_array.length > 1">多合伙人组合</span>
          <span v-else>{{ row.identity_type_array[0] | identityName }}</span>
          <el-tooltip popper-class="tooltip" placement="top" v-if="row.identity_type_array.length > 1">
            <i class="el-icon-warning-outline" style="font-size: 16px"></i>
            <template slot="content">
              <div>合伙人身份</div>
              <div>
                <span v-for="item in row.identity_type_array" :key="item">{{ item | identityName }}、</span>
              </div>
            </template>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="联系人" width="150" align="center"></el-table-column>
      <el-table-column prop="mobile" label="联系电话" width="150" align="center"></el-table-column>
      <el-table-column prop="enterprise_name" label="企业名称" width="180" align="center"></el-table-column>
      <el-table-column prop="city_name" label="所属区域" width="150" align="center"></el-table-column>
      <el-table-column prop="service_sales_amount" label="累计服务订单金额" width="150" align="center">
        <template v-slot="{ row }">￥{{ row.service_sales_amount }}</template>
      </el-table-column>
      <el-table-column prop="service_order_count" label="累计服务订单数" width="150" align="center"></el-table-column>
      <el-table-column prop="goods_sales_amount" label="累计商品订单金额" width="150" align="center">
        <template v-slot="{ row }">￥{{ row.goods_sales_amount }}</template>
      </el-table-column>
      <el-table-column prop="goods_order_count" label="累计商品订单数" width="150" align="center"></el-table-column>
      <el-table-column prop="goods_commission_amount" label="商品佣金" width="120" align="center">
        <template v-slot="{ row }">￥{{ row.goods_commission_amount }}</template>
      </el-table-column>
      <el-table-column prop="service_commission_amount" label="服务佣金" width="120" align="center">
        <template v-slot="{ row }">￥{{ row.service_commission_amount }}</template>
      </el-table-column>
      <el-table-column prop="can_withdraw_amount" label="可提现金额" width="120" align="center">
        <template v-slot="{ row }">￥{{ row.can_withdraw_amount }}</template>
      </el-table-column>
      <el-table-column prop="create_time" label="注册时间" width="180" align="center">
        <template v-slot="{ row }">{{ row.create_time | getDateformat }}</template>
      </el-table-column>
      <!-- <el-table-column label="操作" align="center" fixed="right" width="120">
        <template v-slot="{ row }">
          <el-button @click="details(row.id)" type="text" size="small">详情</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <Paging :total="total_number" :page="searchForm.page" :pageNum="searchForm.rows" @updatePageNum="updateData"></Paging>
  </el-main>
</template>

<script>
import userInfo from '@/components/userInfo';
import { getDateformat } from '@/util/getDate';
import Paging from '@/components/paging';

export default {
  name: 'partnerList',
  components: {
    userInfo,
    Paging,
  },
  data() {
    return {
      searchForm: {
        page: 1,
        rows: 10,
      },
      list: [],
      total_number: 0,
    };
  },
  filters: {
    getDateformat: getDateformat,
    identityName(type) {
      let name = '';
      switch (type) {
        case 17:
          name = '产品合伙人';
          break;
        case 19:
          name = '城市合伙人';
          break;
        case 21:
          name = '市场合伙人';
          break;
        default:
          name = '未知类型';
          break;
      }
      return name;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    details(id) {
      this.$router.push({
        path: '/member/info',
        query: {
          id: id
        },
      });
    },
    getList() {
      this.$axios.post(this.$api.gateway.member.partnerList, this.searchForm).then(res => {
        if (res.code == 0) {
          let list = res.result.list;
          // 处理身份类型字符串转数组
          for (let i in list) {
            list[i].identity_type_array = list[i].identity_type.split(',').map(Number);
          }
          this.list = list;
          this.total_number = res.result.total_number;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    updateData(e, type) {
      if(type === 0) {
        this.searchForm.rows = e;
      }
      if(type === 1) {
        this.searchForm.page = e;
      }
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.el-main {
  background: #fff;
}
</style>